export const NOTIFICATIONS_TYPE = {
    THRESHOLD : "threshold",
    DISEASE : "disease"
}